const subGroupEl = document.querySelector('.subgroup--list');
const subGroupBtnEl = document.querySelector('.api-page--subGroup-btn')

const getSubGroups = async (TOKEN) => {
    console.log(TOKEN);
    const subGroupResponse = await fetch("https://ro.boldapps.net/api/third_party/subscription_groups?shop=bold-clifford.myshopify.com", {
        headers: {
            'BOLD-Authorization': `Bearer ${TOKEN}`,
            'Content-Type': 'application/json',
        }
    });

    const subGroupData = await subGroupResponse.json();
    const subscriptionGroups = subGroupData.subscription_groups; //extract the sub groups from the fetched data
    console.log(subscriptionGroups);

  //map over all the elements fetched and for each element, create a div and print the name of the group to the UI
    subscriptionGroups.map((el) => {
        subGroupEl.insertAdjacentHTML('beforeend', `<div id="sub-el">${el.group_name}</div>`);
    })
}

const getToken = async () => {
    //subgroups-apiKey is the name of the API key created in the App
    const tokenResponse = await fetch("https://ro.boldapps.net/api/auth/third_party_token?shop=bold-clifford.myshopify.com&handle=subgroups-apiKey", {

        headers: {
            'BOLD-Authorization': "da3fdc835365ad823b792b082b03b0ee123a7d5cad63696145f4ab0929d3b91296c5c258ed42a37f3bf17259c1df9856a45bc05bd922a421a1554195857493c9",
        }
    });

    const tokenData = await tokenResponse.json();
    const TOKEN = tokenData.token;
    getSubGroups(TOKEN); //make another fetch after the token is obtained
}

//add an event listener to the button
subGroupBtnEl.addEventListener("click", () => {
    subGroupEl.innerHTML = "";                           
    getToken();//call the getToken function when the button is clicked
})


/*
To disable web security, I used a cmd line flag to disable CORS. Run the code below in Terminal. Use the new browser that it opens up.

open -na Google\ Chrome --args --user-data-dir=/tmp/temporary-chrome-profile-dir --disable-web-security


*/